const footerLinks = {
  comic: {
    title: '漫画分类',
    items: [
      { label: '星际战争漫画', href: '#index' },
      { label: '太空冒险漫画', href: '#index' },
      { label: '外星文明漫画', href: '#index' },
      { label: '时空穿越漫画', href: '#index' },
      { label: '科幻悬疑漫画', href: '#index' },
      { label: '末日生存漫画', href: '#index' },
    ],
  },
  platform: {
    title: '平台导航',
    items: [
      { label: '人气榜单', href: '#ranking' },
      { label: '焦点专题', href: '#carousel' },
      { label: '精选推荐', href: '#cards' },
      { label: '最新动态', href: '#updates' },
      { label: '热门话题', href: '#topics' },
      { label: '读者热评', href: '#comments' },
    ],
  },
  about: {
    title: '关于',
    items: [
      { label: '关于我们', href: '#about' },
      { label: '联系我们', href: '#contact' },
      { label: '常见问答', href: '#faq' },
      { label: '移动阅读', href: '#app' },
      { label: '平台特色', href: '#features' },
      { label: '作者投稿', href: '#contact' },
    ],
  },
};

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8 md:mb-10">
          <div className="col-span-2 md:col-span-1">
            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); handleClick('#hero'); }}
              className="flex items-center gap-2 mb-4 no-underline"
            >
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-planet-line text-2xl text-primary-500"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                星球漫画
              </span>
            </a>
            <p className="text-xs md:text-sm leading-relaxed text-background-300/70 mb-4">
              星球漫画是专业的星际漫画、科幻漫画、宇宙漫画免费在线阅读平台。
              提供下拉式阅读体验，每日更新海量科幻漫画资源，是您探索宇宙故事的最佳伙伴。
            </p>
            <div className="flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-vidicon-line'].map((icon) => (
                <a
                  key={icon}
                  href="#footer"
                  className="w-8 h-8 rounded-full bg-background-800/50 hover:bg-primary-500/80 flex items-center justify-center transition-colors no-underline cursor-pointer"
                >
                  <i className={`${icon} text-background-200/80 text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h3 className="text-sm font-heading font-bold text-background-100 mb-3 md:mb-4 whitespace-nowrap">
                {section.title}
              </h3>
              <ul className="space-y-2">
                {section.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
                      className="text-xs md:text-sm text-background-300/60 hover:text-background-100 transition-colors no-underline whitespace-nowrap"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800/40 pt-6 mb-6">
          <h3 className="text-sm font-heading font-bold text-background-100 mb-3 whitespace-nowrap">
            合作伙伴
          </h3>
          <p className="text-xs text-background-300/40">
            更多合作伙伴信息敬请期待
          </p>
        </div>

        <div className="border-t border-background-800/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400/50 whitespace-nowrap">
            &copy; 2026 星球漫画. 探索宇宙故事的无限可能.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <a href="#footer" className="text-xs text-background-400/50 hover:text-background-200/70 transition-colors no-underline whitespace-nowrap">
              用户协议
            </a>
            <a href="#footer" className="text-xs text-background-400/50 hover:text-background-200/70 transition-colors no-underline whitespace-nowrap">
              隐私政策
            </a>
            <a href="#footer" className="text-xs text-background-400/50 hover:text-background-200/70 transition-colors no-underline whitespace-nowrap">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}